var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 8V17H27",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 32V23H13",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5709C8.72824 13.5228 9.96593 11.6916 11.5976 10.2483C13.2293 8.80499 15.2017 7.79655 17.3309 7.3171C19.4601 6.83764 21.6766 6.90279 23.7736 7.50647C25.8706 8.11015 27.7799 9.23268 29.3231 10.7693L36 17",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23L10.6769 29.2307C12.2202 30.7673 14.1294 31.8899 16.2264 32.4935C18.3234 33.0972 20.5399 33.1624 22.6691 32.6829C24.7983 32.2034 26.7707 31.195 28.4024 29.7517C30.0341 28.3084 31.2718 26.4772 32 24.4291",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.97a49265ec3cf2de88abea634403789f.svg";
export { ForwardRef as ReactComponent };